import express, { Router } from 'express';

import * as companyValidation from '@/modules/company/company.validation';
import * as companyController from '@/modules/company/company.controller';

import { validateMiddleware } from '@/shared/utils/middlewares/index';
import userAuthAndCheckPermissions from '@/modules/auth/auth.user.middleware';
import { setAuditFields } from '@/shared/middleware/setAuditFields';
import { AuditMode } from '@/shared/constants/enum.constant';
import { MODULE_LIST } from '@/shared/constants/module.constant';
import { ACTIONS } from '@/shared/constants';

const router: Router = express.Router();

router
  .route('/')
  .get(
    userAuthAndCheckPermissions(MODULE_LIST.COMPANY, ACTIONS.READ),
    validateMiddleware(companyValidation.getCompanies),
    companyController.getCompanies,
  )
  .post(
    userAuthAndCheckPermissions(
      MODULE_LIST.COMPANY, ACTIONS.CREATE,
    ),
    validateMiddleware(companyValidation.createCompany()),
    setAuditFields({ mode: AuditMode.CREATE }),
    companyController.createCompany,
  );

router
  .route('/temp/activate')
  .post(
    userAuthAndCheckPermissions(MODULE_LIST.COMPANY, ACTIONS.UPDATE),
    companyController.tempActivateCompany,
  );

router
  .route('/:id')
  .get(
    userAuthAndCheckPermissions(
      // MODULE_LIST.COMPANY, ACTIONS.READ,
    ),
    validateMiddleware(companyValidation.getCompanyById),
    companyController.getCompanyById,
  )
  .patch(
    userAuthAndCheckPermissions(
      MODULE_LIST.COMPANY, ACTIONS.UPDATE,
    ),
    validateMiddleware(companyValidation.updateCompany()),
    setAuditFields({ mode: AuditMode.UPDATE }),
    companyController.updateCompany,
  )
  .delete(
    userAuthAndCheckPermissions(
      MODULE_LIST.COMPANY, ACTIONS.DELETE,
    ),
    validateMiddleware(companyValidation.deleteCompanyById),
    companyController.deleteCompanyById,
  );

export default router;
